/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'update';
const componentName = 'update-card';
const prefix = `${moduleName}.${componentName}`;

export const inProgressLabel = `${prefix}.inProgressLabel`;
export const viewProgressLabel = `${prefix}.viewProgressLabel`;

export const ENGLISH = {
    [inProgressLabel]: 'In Progress',
    [viewProgressLabel]: 'View Progress',
};
